import type { TrialMembership } from "@/stores/support/trials";

export type LeadFilter = "leads" | "converted" | "suppressed" | "all";

export const isSuppressed = (lead: Pick<TrialMembership, "status">) =>
  lead.status === "rejected" || lead.status === "cancelled";

export const isConverted = (lead: Pick<TrialMembership, "status">) =>
  lead.status === "converted";

export const matchesLeadFilter = (
  lead: Pick<TrialMembership, "status">,
  filter: LeadFilter
): boolean => {
  if (filter === "all") return true;
  if (filter === "converted") return isConverted(lead);
  if (filter === "suppressed") return isSuppressed(lead);
  // "leads" (default): open prospects — not suppressed and not converted
  return !isSuppressed(lead) && !isConverted(lead);
};
